import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";
import { Button, Card, Form, Input, message } from "antd";
import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const CandidateSetPassword = () =>{

    const [ form ] = Form.useForm()
    const navigate = useNavigate();
    const [params] = useSearchParams();

    const candidateId = params.get("candidateId");
    const token = params.get("token");

    const handleSubmit = async ( values ) => {
        if ( values.password !== values.confirmPassword ) {
            message.error("Confirm Password dont mathc");
            return
        }

        try{
              const response = await axiosInstance.post(API.candidate.create,{
                token:token,
                password:values.password
              });
              localStorage.removeItem("candidateId");
              localStorage.removeItem("token");
              message.success("Password Set Successfully");
              setTimeout(() => {
                navigate("/empsignIn");
              }, 2000);
        } catch (error){
            console.error("Error in Set Password", error);
        }
    }

    return(
        <Card title="Set Your Password" style={{ maxWidth: 400, margin: "50px auto" }} >
           <Form form = {form} layout="verticle" onFinish={ handleSubmit}>
            <Form.Item
              label="Password"
              name="password"
              rules={[{ required:true , message:"Please Enter Your Password"},
                {min:8, message:"Password should be at least 8 characters"}
              ]}>
                <Input.Password/>
              </Form.Item>

              <Form.Item
               label="Confirm Password"
               name = "confirmPassword"
               rules={[{ required: true, message: "Please Confirm your Password"}]}>
                <Input.Password />
               </Form.Item>
               <Button htmlType="submit" className="btn-primary">
                Set Password
               </Button>
           </Form>
        </Card>
    )

};

export default CandidateSetPassword;